import { useContext } from 'react'
import get from 'lodash/get'

import { FnaContext } from '../../../context'
import { sumSelectedAssets, sumSelectedLiabilities, sumSelectedRiskProducts } from '../../../utils'
import { ASSESSMENT_TYPE } from '../../../reducer'

export const buildInitialValues = () => {
  const {
    state: {
      fna: {
        [ASSESSMENT_TYPE.LIFE_COVER]: assessment
      },
      assets,
      riskProducts,
      liabilities,
      supportedCurrencies
    }
  } = useContext(FnaContext)
  const assetables_attributes = get(assessment, 'assetables', [])
  const liabilitiables_attributes = get(assessment, 'liabilitiables', [])
  const risk_productables_attributes = get(assessment, 'risk_productables', [])

  return {
    total_additional_assets: get(assessment, 'total_additional_assets', 0),
    total_from_selected_assets: sumSelectedAssets(assets, assetables_attributes, supportedCurrencies),
    total_existing_life_cover: get(assessment, 'total_existing_life_cover', 0),
    total_additional_liabilities: get(assessment, 'total_additional_liabilities', 0),
    total_from_selected_liabilities: sumSelectedLiabilities(liabilities, liabilitiables_attributes, assets, assetables_attributes),
    total_from_selected_risk_products: sumSelectedRiskProducts(riskProducts, risk_productables_attributes),
    total_provision: get(assessment, 'total_provision', 0),
    total_requirement: get(assessment, 'total_requirement', 0),
    include_estate_duty_in_required_cover: get(assessment, 'include_estate_duty_in_required_cover', true),
    dependents: get(assessment, 'dependents', []),
    assetables_attributes,
    liabilitiables_attributes,
    risk_productables_attributes,
  }
}
